// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-searching-input__container {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
    flex-grow: 1;
}

input.tag-searching-input__input {
    min-width: 10rem;
    border: none !important;
    border-bottom: 1px solid #9e9e9e !important;
    margin-bottom: 0 !important;
    line-height: 1.5 !important;
    padding-left: 0.4rem !important;
    height: 3rem;
}

.clear-filter {
    color: #666666;
    cursor: pointer;
    border-bottom: 1px solid #9e9e9e;
    display: flex;
    align-items: center;
    height: 3rem;
}

.clear-filter:hover {
    color: #fff;
    background: #26a69a;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-searching-input/TagSearchingInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,2CAA2C;IAC3C,2BAA2B;IAC3B,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".tag-searching-input__container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    overflow-x: auto;\r\n    flex-grow: 1;\r\n}\r\n\r\ninput.tag-searching-input__input {\r\n    min-width: 10rem;\r\n    border: none !important;\r\n    border-bottom: 1px solid #9e9e9e !important;\r\n    margin-bottom: 0 !important;\r\n    line-height: 1.5 !important;\r\n    padding-left: 0.4rem !important;\r\n    height: 3rem;\r\n}\r\n\r\n.clear-filter {\r\n    color: #666666;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 3rem;\r\n}\r\n\r\n.clear-filter:hover {\r\n    color: #fff;\r\n    background: #26a69a;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
